<template lang="html">
  <!-- <div v-show="this.settings !== undefined && this.settings.enableArticleList === 1" class="article-layer" :id="_uid + '-article-layer'" @click="articleClicked()"> -->
    <div v-show="this.settings !== undefined && this.settings.enableArticleList === 1" class="article-layer" :id="_uid + '-article-layer'">
  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

import { setZIndexesForElements } from './CciZIndexLayers.js'

export default {
  props: ['article'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    const div = document.getElementById(this._uid + '-article-layer')
    div.removeEventListener('pageSingleClick', this.articleClicked, false)
    div.addEventListener('pageSingleClick', this.articleClicked, false)

    var box1 = this.getBox(this.article)
    var box2 = this.getBox(this.article.page)

    var x = box1.x / box2.width
    var y = box1.y / box2.height
    var width = box1.width / box2.width
    var height = box1.height / box2.height

    if (width > 1) {
      width = 1
    }

    div.style.left = x * 100 + '%'
    div.style.top = y * 100 + '%'
    div.style.width = width * 100 + '%'
    div.style.height = height * 100 + '%'

    setZIndexesForElements(document.getElementsByClassName('article-layer'), 100)
    this.applySettings(this.settings)
  },
  computed: {
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      isScrolling: 'getIsScrolling',
      settings: 'getSettings',
      currentArticle: 'getCurrentArticle'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined && settings.enableInteractionLayerHoverEffect) {
        var layers = document.getElementsByClassName('article-layer')
        for (var i = 0; i < layers.length; i++) {
          layers[i].classList.add("article-layer-hover")
        }
      }
    },
    articleClicked () {
      if (!this.isScrolling) {
        // close overlays
        if (this.$store.state.showRightAlignedNavigationBar || this.$store.state.showLeftAlignedScrubber) {
          this.$store.commit('setShowRightAlignedNavigationBar', false)
          this.$store.commit('setShowLeftAlignedScrubber', false)
          return
        }

        if (this.$store.state.showScrubber) {
          this.$store.commit('toggleScrubberVisible')
        }

        let burgerButton = document.getElementById('burger-button')
        let slider = document.getElementById('nav-right-pages')
        if (slider !== null && burgerButton !== null) {
          burgerButton.classList.remove('rotate-90-degree')
          slider.classList.remove('move-right')
        }

        // if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement) {
        //   if (document.exitFullscreen) {
        //     document.exitFullscreen()
        //   } else if (document.msExitFullscreen) {
        //     document.msExitFullscreen()
        //   } else if (document.mozCancelFullScreen) {
        //     document.mozCancelFullScreen()
        //   } else if (document.webkitExitFullscreen) {
        //     document.webkitExitFullscreen()
        //   }
        // }

        var hasJumpOriginArticle = this.article.attributes.JumpOriginArticleId !== undefined
        if (hasJumpOriginArticle) {
          this.$store.commit('setCurrentArticleFromIds', {'articleId': this.article.attributes.JumpOriginArticleId, 'pageId': this.article.attributes.JumpOriginPageId})
          this.$store.commit('setSelectedPageChild', this.currentArticle)
          this.$store.commit('setShowArticleModal', true)
          return
        }

        var hasJumpToArticleId = this.article.attributes.jumpToArticleId !== undefined && this.article.attributes.jumpToArticleId !== ''
        var hasJumpToPageId = this.article.attributes.JumpToPage !== undefined && this.article.attributes.JumpToPage !== '' && this.article.attributes.JumpTo !== undefined && this.article.attributes.JumpTo !== '' && this.article.attributes.IsEntryJump !== undefined

        if (hasJumpToPageId && !hasJumpToArticleId) {
          this.$store.commit('setCurrentPageFromId', this.article.attributes.JumpToPage)
          return
        }

        if (hasJumpToPageId && hasJumpToArticleId) {
          // TO-DO: check if jump page id is correct! (I think so....) /HKN.
          // Note: This type of jump is not active for MCC.
          this.$store.commit('setCurrentPageFromId', this.article.attributes.JumpToPage)
          this.$store.commit('setCurrentArticleFromIds', {'articleId': this.article.attributes.jumpToArticleId, 'pageId': this.article.attributes.JumpToPage})
          this.$store.commit('setSelectedPageChild', this.currentArticle)
          this.$store.commit('setShowArticleModal', true)
          return
        }

        this.$store.commit('setCurrentArticleFromIds', {'articleId': this.article.id, 'pageId': this.article.page.id})
        this.$store.commit('setSelectedPageChild', this.currentArticle)
        this.$store.commit('setShowArticleModal', true)
      }
    },
    getBox (obj) {
      return {
        x: parseFloat(obj.attributes.ObjectXPos),
        y: parseFloat(obj.attributes.ObjectYPos),
        width: parseFloat(obj.attributes.ObjectWidth),
        height: parseFloat(obj.attributes.ObjectHeight)
      }
    },
    // getVisibleId () {
    //   const div = document.getElementById(this._uid + '-article-layer')
    //   const rect = div.getBoundingClientRect()
    //   // Check for partial visibility:
    //   const isVisible = (
    //     rect.bottom >= 0 &&
    //     rect.right >= 0 &&
    //     rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    //     rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    //   )
    //   if (isVisible) return [this.article.id]
    //   return []
    // },
    getArticleIfInCenter () {
      const div = document.getElementById(this._uid + '-article-layer')
      const rect = div.getBoundingClientRect()

      const windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth
      const windowHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight
      const centerX = windowWidth / 2
      const centerY = windowHeight / 2

      const isInCenter = (
        rect.bottom >= centerY &&
        rect.top < centerY &&
        rect.left <= centerX &&
        rect.right > centerX
      )

      if (isInCenter) return this.article
    }
  }
}
</script>

<style lang=scss>
.article-layer {
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.article-layer-hover {
  &:hover {
    background-color: #2980b9;
    opacity: 0.1;
  }
}
</style>
